<template>
  <div class="flex flex-wrap mb-3" v-if="!isUserReady">
    <div v-if="false" class="lg:px-6 lg:w-full md:px-6 md:w-full sm:w-full w-full xl:px-3 xl:w-full xs:w-full z-0">
      <DownloadLinkMobileApp />
    </div>

    <template v-if="loading">
      <div class="lg:px-6 lg:w-full md:p-4 md:px-6 md:w-full sm:w-full w-full xl:px-3 xl:w-full xs:w-full h-48 z-0">
        <vue-loading :active="loading" color="#4F41A3" :is-full-page="false" />
      </div>
    </template>
    <template v-else>
      <div class="lg:px-6 lg:w-full md:px-6 md:w-full sm:w-full w-full xl:px-3 xl:w-full xs:w-full mb-4">
        <AlertSichernConnectNotificacion
          :key="sichernConnectAlertColor"
          v-model="showSichernConnectAlert"
          :color="sichernConnectAlertColor"
          :title="sichernConnectAlertTitle"
          :message="sichernConnectAlertMessage"
          :shown-button-close="true"
        />
      </div>
      <div v-if="showLinkKeycloakAlert" class="lg:px-6 lg:w-full md:px-6 md:w-full sm:w-full w-full xl:px-3 xl:w-full xs:w-full mb-4">
        <AlertKeyCloak :type="linkKeycloakAlertType" @close="closeKeyCloakAlert"/>
      </div>
      
      <div class="lg:px-6 lg:w-1/3 md:p-4 md:px-6 md:w-1/3 sm:w-full w-full xl:px-3 xl:w-1/4 xs:w-full">
        <LeftMenu v-on:changeAvatar="avatarChanged" :key="'lm' + reRenderKey"></LeftMenu>
        <SectionsHome :key="'sh' + reRenderKey"></SectionsHome>
      </div>
      <div class="w-full xs:w-full sm:w-full md:w-2/3 lg:w-2/3 xl:w-3/4 lg:px-4 xl:px-4 overflow-hidden">
        <HomeContainer class="mt-3" :key="'hm' + reRenderKey"></HomeContainer>
        <v-card v-if="this.isUserActive && (birthdayAccess || recentHiredAccess)" :key="'vc' + reRenderKey"
          class="rounded mt-3">
          <v-tabs slider-color="buttonSecondary" height="70px" v-model="selectedTab">
            <v-tab v-show="birthdayAccess" class="normal-case">
              <div class="ico__birthday mr-2"></div>
              <div class="text-zt-xl font-normal buttonPrimary--text">
                {{ $t('message.homeComponent.birthdays.title') }}
              </div>
            </v-tab>
            <v-tab v-show="recentHiredAccess" class="normal-case">
              <div class="ico__recentHired mr-2"></div>
              <div class="text-zt-xl font-normal buttonPrimary--text">
                {{ $t('message.homeComponent.recentHired.title') }}
              </div>
            </v-tab>
            <v-tab v-show="absentAccess" class="normal-case">
              <div class="ico__absents mr-2"></div>
              <div class="text-zt-xl font-normal buttonPrimary--text">
                {{ $t('message.homeComponent.absentUsers.title') }}
              </div>
            </v-tab>
            <v-tab-item v-for="n in 3" :key="n" class="border-t">
              <div v-if="n == 1 && birthdayAccess">
                <Birthdays :hasChanged="changedAvatar" :filterSector="selectedSectorBirthdays" class="mt-3"></Birthdays>
              </div>
              <div v-if="n == 2 && recentHiredAccess">
                <recentHired />
              </div>
              <div v-if="n == 3 && absentAccess">
                <AbsentUsers />
              </div>
            </v-tab-item>

            <ul class="d-flex ml-auto">
              <li class="flex items-center ml-auto mr-2">
                <div class="flex items-center" v-show="selectedTab == 0 && birthdayAccess">
                  <SelectIconFilter v-model="selectedSectorBirthdays" :items="['Ver todos', $t('message.dashboard.seeMembers')]" />
                </div>
                <div class="text-zt-dark-300 text-zt-md" v-show="selectedTab === 2 && absentAccess && currentUser.sector
                  ">
                  <p>Sector: {{ currentUser.sector }}</p>
                </div>
              </li>
            </ul>
          </v-tabs>
        </v-card>
      </div>
      <zt-modal :active="notificationModal" @close="closeNotificationModal()" max-width="42rem" :z-index="200">
        <template slot="modal-header">
          <div class="p-4 font-normal text-zt-lg">
            {{ $t('message.notifications.new_update') }}
          </div>
        </template>
        <NotificationBody :modal-content="notificationModalContent" />
        <div class="zt-modal-footer border-b flex justify-end items-center p-4 md:relative bottom-0 right-0 left-0">
          <div class="w-1/2 md:w-1/4">
            <zt-button data-vs-button="close-notification" class="ml-1 w-11/12" @click="closeNotificationModal()">{{
              $t('message.notifications.understood') }}</zt-button>
          </div>
        </div>
      </zt-modal>
    </template>

    <DownloadModal :activeModal="downloadActive" :expiredStatus="expiredStatus" :closeModal="closeDialog"
      :fileLink="fileLink" />

    <SwitchCompanyFactory v-if="waitForCompanyChangeData" :active-modal="waitSwitchActiveModal"
      :company-info="waitForCompanyChangeData" :loader="waitForCompanyChange" />

    <SichernConnect />
  </div>
</template>
<script>
import Users from '../../../apiClient/Users'
import Actions from '../../../apiClient/Actions'
import Notifications from '../../../apiClient/Notifications'
import LeftMenu from '../components/LeftMenu'
import HomeContainer from '../components/HomeContainer'
import SectionsHome from '../components/SectionsHome'
import Birthdays from '../components/Birthdays'
import AbsentUsers from '../components/AbsentUsers'
import recentHired from './RecentHired'
import SelectIconFilter from '../components/SelectIconFilter'
import PopupNewVersionWe from '../components/PopupNewVersionWe'
import { find, isEmpty } from 'lodash'
import { mapActions, mapGetters, mapState } from 'vuex'
import DownloadModal from './Modals/DownloadModal'
import SwitchCompanyFactory from './Modals/SwitchCompanyWithFactory'
import NotificationBody from './Modals/NotificationBody'
import { useWindowResize } from '@sichern/ui-elements'
import DownloadLinkMobileApp from '../components/DownloadLinkMobileApp'
import AlertKeyCloak from './NoProvisioningKeyCloakAlert.vue'
import SichernConnect from '@/components/SichernConnect/SichernConnect.vue'
import AlertSichernConnectNotificacion from '@/components/SichernConnect/AlertSichernConnectNotificacion.vue'

export default {
  components: {
    LeftMenu,
    HomeContainer,
    SectionsHome,
    Birthdays,
    recentHired,
    SelectIconFilter,
    PopupNewVersionWe,
    DownloadModal,
    SwitchCompanyFactory,
    AbsentUsers,
    NotificationBody,
    DownloadLinkMobileApp,
    AlertKeyCloak,
    SichernConnect,
    AlertSichernConnectNotificacion
  },
  data() {
    return {
      windowResize: useWindowResize(this),
      changedAvatar: 0,
      user: '',
      loading: false,
      birthdayAccess: false,
      recentHiredAccess: false,
      absentAccess: false,
      selectedSectorBirthdays: 'Ver todos',
      selectedTab: null,
      more: ['News', 'Maps', 'Books', 'Flights', 'Apps'],
      downloadActive: false,
      expiredStatus: false,
      fileLink: '',
      reRenderKey: 0,
      waitForCompanyChange: false,
      waitForCompanyChangeData: null,
      waitSwitchActiveModal: false,
      linkUsersModalActive: false,
      titleModal: '',
      componentBodyModal: '',
      linkUsersModalStep3Active: false,
      buttonAfterDisabled: false,
      notificationModal: false,
      notificationModalContent: {},
      showLinkKeycloakAlert: false,
      linkKeycloakAlertType: '',
      showSichernConnectAlertValue: false,
      dismissedExpiredAlert: false
    }
  },
  async created() {
    this.loading = true
    window.scrollTo(0, 0)
    this.user = new Users()
    this.actions = new Actions()
    this.notifications = new Notifications()
    this.checkLinkKeycloakResult()

    await this.setProfile()
    const user = this.getProfile
    this.$store.dispatch('setUser', { user })
    this.$store.dispatch('sichernConnect/requestLinkingStatus')
    this.$store.dispatch('getAvatar', { userId: user.id })
    let prevRoute = localStorage.getItem('prevRoute')

    const usersRelated = await this.getUserRelated()
    if (usersRelated.length > 1) {
      await Promise.all(
        usersRelated.map(async items => {
          try {
            !items.empresa.companyLogo
              ? (items.empresa.companyLogo = await this.user.getCompanyLogo(
                items.empresa.id
              ))
              : ''
          } catch (e) { }
        })
      )
    }
    this.$store.dispatch('setUsersRelated', { usersRelated })

    if (parseInt(user.estado_empresa, 10) === 1) {
      await this.$store.dispatch('setStateNotOnboarding', true)
    }
    for (let key in user.perfiles) {
      if (parseInt(user.perfiles[key].id_perfil_tipo, 10) === 1) {
        let checkUserEmployee = true
        await this.$store.dispatch('setCheckUserEmployee', checkUserEmployee)
      }
    }

    if (this.$store.getters.getCheckUserEmployee === false) {
      this.$router.push('rrhhredirect')
    }
    this.loading = false
    //MOMENTANEO MIENTRAS ESTE EN VERSION BETA
    this.$store.dispatch('setActions').then(() => {
      for (let action of this.$store.getters.getActions) {
        if (action.id === '83') {
          this.birthdayAccess = true
        }
        if (action.id === '84') {
          this.recentHiredAccess = true
        }
        if (action.id === '85') {
          this.absentAccess = true
        }
      }
    })

    if (prevRoute === 'login') {

      this.notifications
        .checkNotificationActive()
        .then(res => {

          this.notificationModalContent = res.data
          this.notificationModal = true
        })
        .catch((error) => {
          console.log(error)
        })
    }
    if (this.factoryCurrentCompanyIsAvailable()) {
      this.checkDownloadAvailable()
    } else {
      const employee = this.findFactoryCompanyIsAvailable()
      if (employee) {
        const userId = employee.id
        this.waitForCompanyChangeData = employee
        this.waitSwitchActiveModal = true
        this.waitForCompanyChange = true

        await this.getProfileByIdPatchUserRelated(userId)
        await this.setUser({ user: employee })
        await this.getAvatar({ userId })
        await this.getLogoCompany(employee.empresa.id)
        await this.setActions()

        this.waitForCompanyChange = false
        this.reRenderKey += 1

        setTimeout(() => {
          this.waitForCompanyChangeData = null
          this.waitSwitchActiveModal = false
          this.setParamLoginFactory('')
          this.checkDownloadAvailable()
        }, 3000)
      }
    }
  },
  methods: {
    ...mapActions({
      getLogoCompany: 'getLogoCompany',
      getProfileByIdPatchUserRelated: 'getProfileByIdPatchUserRelated',
      setParamLoginFactory: 'auth/setParamLoginFactory',
      setUser: 'setUser',
      getAvatar: 'getAvatar',
      setActions: 'setActions',
      setProfile: 'setProfile',
      getUserRelated: 'getUserRelated',
      clearLinkKeycloakResult: 'clearLinkKeycloakResult'
    }),

    avatarChanged(value) {
      this.changedAvatar = value
    },
    closeDialog() {
      if (this.waitForCompanyChange) {
        return
      }
      this.setParamLoginFactory('')
      this.downloadActive = false
    },
    factoryCurrentCompanyIsAvailable() {
      const factory = parseInt(this.getFactoryStringParam, 10)
      const id = this.$store.getters.getUser.empresa.id
      return factory === id
    },
    findFactoryCompanyIsAvailable() {
      return find(this.$store.getters.getUsersRelated, user => {
        return user.empresa.id === parseInt(this.getFactoryStringParam, 10)
      })
    },
    checkDownloadAvailable() {
      this.user
        .getDownloadAvailable()
        .then(responseAvailable => {
          if (responseAvailable.data.data.ready) {
            this.user
              .getDownloadFile()
              .then(responseBinary => {
                this.downloadActive = true
                this.expiredStatus = false
                this.fileLink = responseBinary.data.data.link
              })
              .catch(() => {
                this.downloadActive = true
                this.expiredStatus = true
              })
          }
        })
        .catch(() => {
          this.downloadActive = true
          this.expiredStatus = true
        })
    },
    async closeNotificationModal() {
      this.notificationModal = false
    },
    checkLinkKeycloakResult() {
      const linkResult = this.getLinkKeycloakResult
      if (linkResult) {
        this.showLinkKeycloakAlert = true
        this.linkKeycloakAlertType = linkResult 
      }
    },
    closeKeyCloakAlert() {
      this.showLinkKeycloakAlert = false
      this.clearLinkKeycloakResult() 
    }
  },
  computed: {
    ...mapState({ currentUser: 'user' }),
    ...mapGetters({
      isUserActive: 'isUserActive',
      getFactoryStringParam: 'auth/getFactoryStringParam',
      getProfile: 'getProfile',
      getLinkKeycloakResult: 'getLinkKeycloakResult'
    }),
    showSichernConnectAlert: {
      get () {
        return this.$store.state.sichernConnect.hasErrorLinking ||
          this.$store.state.sichernConnect.successLinking ||
          (this.$store.state.profile.expired_password && this.$store.getters['sichernConnect/isAlreadyLinked'] && !this.dismissedExpiredAlert)
      },
      set (val) {
        if (!val) {
          if (this.$store.state.sichernConnect.hasErrorLinking) {
            this.$store.commit('sichernConnect/SET_HAS_ERROR_LINKING', false)
          } else if (this.$store.state.sichernConnect.successLinking) {
            this.$store.commit('sichernConnect/SET_SUCCESS_LINKING', false)
          } else {
            this.dismissedExpiredAlert = true
          }
        }
      }
    },
    isSichernConnectError () {
      return this.$store.state.sichernConnect.hasErrorLinking
    },
    sichernConnectAlertColor () {
      if (this.isSichernConnectError) return 'danger'
      if (this.$store.state.sichernConnect.successLinking) return 'success'
      return 'info'
    },
    sichernConnectAlertTitle () {
      if (this.isSichernConnectError) return this.$t('message.sichernConnect.modal.notification.errorTitle')
      if (this.$store.state.sichernConnect.successLinking) return this.$t('message.sichernConnect.modal.notification.successTitle')
      return this.$t('message.sichernConnect.modal.notification.infoPasswordTitle')
    },
    sichernConnectAlertMessage () {
      if (this.isSichernConnectError) return this.$t('message.sichernConnect.modal.notification.errorMessage')
      if (this.$store.state.sichernConnect.successLinking) return this.$t('message.sichernConnect.modal.notification.successMessage')
      return this.$t('message.sichernConnect.modal.notification.infoPasswordMessage')
    },
    userProfile() {
      return {
        name:
          this.currentUser.nombre.charAt(0).toUpperCase() +
          this.currentUser.nombre.slice(1).toLowerCase()
      }
    },
    isUserReady() {
      return isEmpty(this.currentUser)
    },
    isMobile() {
      return this.windowResize.width < 1024
    }
  },
  beforeRouteEnter(to, from, next) {
    next(() => {
      if (from.name) {
        localStorage.setItem('prevRoute', from.name)
      }
    })
  }
}
</script>

<style lang="scss" scoped>
@import './home.scss';

::v-deep .v-tabs__wrapper {
  contain: unset;
  overflow: visible;
}

::v-deep .v-tabs__container {
  z-index: 8;
}

::v-deep .zt-modal-footer {
  background-color: #eeeeee;

  .zt-button-outline-primary {
    background-color: #eeeeee;
  }
}

::v-deep .v-tabs__slider.buttonSecondary {
  background-color: var(--branding-primary,
      var(--v-buttonSecondary-base)) !important;
  border-color: var(--branding-primary,
      var(--v-buttonSecondary-base)) !important;
}

::v-deep .buttonSecondary--text,
::v-deep .text-zt-secondary-200 {
  color: var(--branding-titleColor, var(--v-buttonSecondary-base)) !important;
  caret-color: var(--branding-titleColor,
      var(--v-buttonSecondary-base)) !important;
}

.border-b {
  border-top-left-radius: 0.375em;
}
</style>
